import { StyleSheet } from "react-native"

export const ReplyButtonStyles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
})
